module.exports = __webpack_public_path__ + "media/Components/fonts/PTSansitalic-468c5f35d044d58761ac0d1835d8cc6c.ttf";